import { useTypePosition } from '../context'
import SnackbarState from '../types/SnackbarState'
import snackbarActions from './snackbarActions'

// Snackbar Status
const success = 'success'
const error = 'error'

// Snackbar Messages
const SUCCESS_MESSAGE = 'El Tipo de Posición ha sido editado correctamente'
const ERROR_MESSAGE = 'Hubo un error al editar el Tipo de Posición'

const snackbarBusiness = () => {
  const {
    dispatch,
    state: { snackbarState }
  } = useTypePosition()

  const { setSnackbarState } = snackbarActions()

  const closeSnackbar = (isOpen: boolean) =>
    dispatch(setSnackbarState({ ...snackbarState, status: '', open: isOpen }))

  const showSnackbar = (message: string, status: string) => {
    const newSnackbarState: SnackbarState = {
      open: true,
      setOpen: closeSnackbar,
      message,
      status
    }

    dispatch(setSnackbarState(newSnackbarState))
  }

  // StatusMessages
  const successMessage = () => showSnackbar(SUCCESS_MESSAGE, success)

  const errorMessage = () => showSnackbar(ERROR_MESSAGE, error)

  return { closeSnackbar, showSnackbar, successMessage, errorMessage }
}

export default snackbarBusiness
